import { title } from "process";

export const PAGES_MENU = [
  {
    path: 'pages',
    children: [
      // {
      //   path: 'dashboard',
      //   data: {
      //     menu: {
      //       title: 'Dashboard',re
      //       icon: 'ion-android-home',
      //       selected: false,
      //       expanded: false,
      //       order: 0
      //     }
      //   }
      // },
      {
        path: 'schedule',
        data: {
          menu: {
            title: 'Schedule',
            icon: 'ion-android-home',
            selected: false,
            expanded: false,
            order: 1, 
            allowCreate:false, allowEdit:false, allowDelete:false
          }
        },
        children: [
          { path: 'mastersche', data: { menu: { title: 'Appointments', hidden: true } } },
          { path: 'checkIn',  data: { menu: { title: 'Check - In' } } },
          { path: 'check-in-list', data: { menu: { title: 'Check Out' } } },
          { path: 'treatment-list', data: { menu: { title: 'Treatment Entry' } } },
          { path: 'treatment-details', data: { menu: { title: 'Treatment Details' } } },
          { path : 'appointment-requests', data: { menu: { title: "Appointment Requests" } } },
          { path : 'employee-transfer', data: { menu: { title: "Employee Transfer" } } }
        ]
          //{ path: 'followup', data: { menu: { title: 'Followup Appointment' } } }]
      },
      {
        path: 'masters',
        data: {
          menu: {
            title: 'Masters',
            icon: 'ion-edit',
            selected: false,
            expanded: false,
            order: 2, 
            allowCreate:false, allowEdit:false, allowDelete:false
          }
        },
        children: [
          { path: 'emp', data: { menu: { title: 'Employee' } } },
          { path: 'cus', data: { menu: { title: 'Customer' } } },
          { path: 'room', data: { menu: { title: 'Room' } } },
          { path: 'ser', data: { menu: { title: 'Service' } } },
          { path: 'series', data: { menu: { title: 'Series' } } },
          { path: 'seriesSales', data: { menu: { title: 'Series Sales' } } },
          { path: 'disease', data: { menu: { title: 'Disease' } } },
          { path: 'medication', data: { menu: { title: 'Medication' } } },
          { path: 'prescription', data: { menu: { title: 'Prescription' } } },
          { path: 'holiday', data: { menu: { title: 'Holiday Entry' } } }
        ]
      }, {
        path: 'userManager',
        data: {
          menu: {
            title: 'User Manager',
            icon: 'ion-android-people',
            selected: false,
            expanded: false,
            order: 5, 
            allowCreate:false, allowEdit:false, allowDelete:false
          }
        },
        children: [
          { path: 'userlist', data: { menu: { title: 'User List' } } }
          , { path: 'roles', data: { menu: { title: 'Roles' } } }]
      },
      {
        path: 'report',
        data: {
          menu: {
            title: 'Reports',
            icon: 'ion-ios-list-outline',
            selected: false,
            expanded: false,
            order: 6,
            allowCreate:false, allowEdit:false, allowDelete:false
          }
        },
        children: [
          { path: 'cusReport', data: { menu: { title: 'Customer Report', allowCreate:false, allowEdit:false, allowDelete:false } } },
          { path: 'empReport', data: { menu: { title: 'Employee Report', allowCreate:false, allowEdit:false, allowDelete:false } } },
          { path: 'roomReport', data: { menu: { title: 'Room Report', allowCreate:false, allowEdit:false, allowDelete:false } } },
          { path: 'serviceReport', data: { menu: { title: 'Service Report', allowCreate:false, allowEdit:false, allowDelete:false } } },
          { path: 'seriesReport', data: { menu: { title: 'Series Report', allowCreate:false, allowEdit:false, allowDelete:false } } },
          { path: 'followupRecords', data: { menu: { title: 'Follow Up Report', allowCreate:false, allowEdit:false, allowDelete:false } } },
          { path: 'messageReport', data: { menu: { title: 'Message Report', allowCreate:false, allowEdit:false, allowDelete:false } } },
          { path: 'activityReport', data: { menu: {title: 'Activity Log', allowCreate:false, allowEdit:false, allowDelete:false} } },
          { path: 'empRoster', data: { menu: {title: 'Employee Roster', allowCreate:false, allowEdit:false, allowDelete:false} } }

          
        ]
      }

    ]
  }]
